module.exports = __webpack_public_path__ + "img/icon-chaleira.496a43e1.svg";